<template>
	<div :class="['customer-benefits--item', 'bg-color-' + color]">
		<div>{{ title }}</div>
		<div v-html="text"/>
	</div>
</template>

<script>
export default {

	props: {
		title: {
			type: String,
			required: true,
		},
		text: {
			type: String,
			required: true,
		},
		color: {
			type: String,
			required: true,
		},
	}
}
</script>
